module.exports = __webpack_public_path__ + "static/faisal-d600cbf1a395004cce661dd6fad23e14.png";